<template>
    <div>
        <vs-card class="p-4">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Replenish Details</h4>
                </div>
                <vs-dropdown vs-trigger-click>
                    <vs-button class="btn-drop" type="filled" icon="apps">Proccess</vs-button>
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="confirmMovement"> View Movement </vs-dropdown-item>
                        <vs-dropdown-item @click="confirmMovement"> Confirm Movement </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Replenish ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.replenish.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.replenish.reference" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Replenish Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.replenish.replenish_date" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Replenish Type*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.replenish.replenish_type_id"
                                width="100%"
                                autocomplete
                                disabled
                            >
                                <vs-select-item v-for="(item, index) in type" :key="index" :value="item.id" :text="item.type"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Client ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.replenish.client_id"
                                width="100%"
                                autocomplete
                                disabled
                            >
                                <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Warehouse ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.replenish.warehouse_id"
                                width="100%"
                                autocomplete
                                disabled
                            >
                                <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                            </vs-select>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details">
                    <div style="max-height: 400px; overflow-x: auto" class="mt-3">
                        <vs-table :data="data.replenish_details" hoverFlat>
                            <template slot="thead">
                                <vs-th>Line ID</vs-th>
                                <vs-th>Product ID</vs-th>
                                <vs-th>Description</vs-th>
                                <vs-th>Pack ID</vs-th>
                                <vs-th>Batch</vs-th>
                                <vs-th>Exp. Date</vs-th>
                                <vs-th>Base Qty</vs-th>
                                <vs-th>Base UoM</vs-th>
                                <vs-th>Stock Type</vs-th>
                                <vs-th>Src. Loc. Type</vs-th>
                                <vs-th>Src. Loc. ID</vs-th>
                                <vs-th>Dest. Loc. Type</vs-th>
                                <vs-th>Dest. Loc. ID</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="detail" :key="index" v-for="(detail, index) in data" >
                                    <vs-td>{{ (index + 1) }}</vs-td>
                                    <vs-td>{{ detail.product_code }}</vs-td>
                                    <vs-td>{{ detail.description }}</vs-td>
                                    <vs-td>{{ detail.pack_id }}</vs-td>
                                    <vs-td>{{ detail.batch }}</vs-td>
                                    <vs-td>{{ detail.expired_date }}</vs-td>
                                    <vs-td>{{ detail.base_qty }}</vs-td>
                                    <vs-td>{{ detail.base_uom_name }}</vs-td>
                                    <vs-td>{{ detail.stock_type_code }}</vs-td>
                                    <vs-td>{{ detail.location_type }}</vs-td>
                                    <vs-td>{{ detail.location_code }}</vs-td>
                                    <vs-td>{{ detail.dest_location_type }}</vs-td>
                                    <vs-td>{{ detail.dest_location_code }}</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </vs-tab>
                <vs-tab label="Notes" class="pt-base">
                    <vs-textarea label="Note" height="200"/>
                </vs-tab>
                <vs-tab label="Attachment" class="pt-base">
                    <vs-row class="w-full">
                        <vs-button class="mr-4" type="border">Add</vs-button>
                        <vs-button class="mr-4" type="border">Remove</vs-button>
                    </vs-row>
                </vs-tab>
            </vs-tabs>
        </vs-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: {
                replenish: {
                    client_code: '',
                    client_id: '',
                    id: '',
                    reference: '',
                    replenish_date: '',
                    replenish_type: '',
                    replenish_type_id: '',
                    warehouse_code: '',
                    warehouse_id: ''
                },
                replenish_details: [],
            },
            type: [],
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            moData: []
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.$router.push({name: 'replenish'})
        },
        fetchData() {
            this.isLoading = true
            Promise.all([this.$http.post('inventories/replenish/show/' + this.$route.params.id)])
            .then(this.$http.spread((res) => {
                this.data = res.data

                this.client.data.push({
                    id: res.data.replenish.client_id,
                    client_code: res.data.replenish.client_code
                })

                this.warehouse.data.push({
                    id: res.data.replenish.warehouse_id,
                    warehouses_code: res.data.replenish.warehouse_code
                })

                this.type.push({
                    id: res.data.replenish.replenish_type_id,
                    type: res.data.replenish.replenish_type
                })

                this.isLoading = false
            }))
            .catch(error => {
                this.isLoading = false
                console.log(error)
            })
        },
        confirmMovement() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: 'Confirmation',
                text: 'Confirm movement orders?',
                accept: () => {
                    this.isLoading = true
                    const data = {
                        transaction_source: this.$route.params.id,
                        transaction_types: ['REPLENISH']
                    }
                    this.$http.post('inventories/movementorder/getoutstanding', data)
                    .then(res => {
                        res.data.movement_order_id.map(item => {
                            this.moData.push({
                                'id': item
                            })
                        })
                        this.acceptMo()
                    })
                    .catch(error => this.handleError(error))
                },
                acceptText: 'Yes',
                cancelText: 'No'
            })
        },
        acceptMo() {
            this.isLoading = true
            this.$http.post('putaway/confirmputaway', {'list_putaway': JSON.stringify(this.moData)})
            .then(() => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'Success confirm'
                })
                
                this.fetchData()
                this.isLoading = false
            })
            .catch(error => console.log(error))
        },
    },
    mounted() {
        this.fetchData()
    }
};
</script>